(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["crosssell-grid"] && !Shopify.designMode) return;
  try {
    (function () {
    'use strict';

    var RESET_MS = 2000;
    var _sheet = null;
    var _backdrop = null;
    var _activeCard = null;
    var _activeVariants = [];
    var _activeOptionNames = [];
    var _currentSelections = [];

    /* Fallback UI Sync if Web Components are missing */
    /* ── Horizon cart count — section rendering approach ── */
    function getHeaderSectionId() {
      var h = document.querySelector('.header-section');
      if (h) { var w = h.closest('[id^="shopify-section-"]'); if (w) return w.id.replace('shopify-section-', ''); }
      var c = document.getElementById('header-component');
      if (c) { var w = c.closest('[id^="shopify-section-"]'); if (w) return w.id.replace('shopify-section-', ''); }
      return null;
    }

    function updateCartBubble(sectionHtml) {
      try {
        var doc = new DOMParser().parseFromString(sectionHtml, 'text/html');
        var nb = doc.querySelector('cart-notification-bubble');
        var lb = document.querySelector('cart-notification-bubble');
        if (nb && lb) { lb.outerHTML = nb.outerHTML; return; }
        var ni = doc.querySelector('.header-actions__cart-icon');
        var li = document.querySelector('.header-actions__cart-icon');
        if (ni && li) { li.innerHTML = ni.innerHTML; return; }
        var na = doc.querySelector('header-actions');
        var la = document.querySelector('header-actions');
        if (na && la) la.innerHTML = na.innerHTML;
      } catch (e) { console.warn('[HPS Grid] Cart bubble update failed:', e); }
    }

    function flyToCart(imgEl) {
      if (!imgEl) return;
      var widget = document.querySelector('[data-hps-cg]');
      if (widget && widget.dataset.hpsAtcAnimation === 'false') return;
      var dest = document.querySelector('.header-actions__cart-icon');
      if (!dest) return;
      try {
        var flyEl = document.createElement('fly-to-cart');
        flyEl.style.setProperty('background-image', 'url(' + imgEl.src + ')');
        flyEl.useSourceSize = 'true';
        flyEl.source = imgEl;
        flyEl.destination = dest;
        document.body.appendChild(flyEl);
      } catch (e) {}
    }

    /* Quantity Stepper Initialization (Bottom Sheet Only) */
    function initQty(container) {
      /* Idempotency guard — prevents duplicate listeners from repeated findSheet calls */
      if (container.dataset.qtyInit) return;
      container.dataset.qtyInit = '1';
      var input = container.querySelector('.hps-cg__qty-input');
      var minus = container.querySelector('[data-qty-minus]');
      var plus  = container.querySelector('[data-qty-plus]');
      if (!input || !minus || !plus) return;

      function updateMinus() {
        minus.disabled = parseInt(input.value, 10) <= 1;
      }

      minus.addEventListener('click', function () {
        var v = parseInt(input.value, 10) || 1;
        if (v > 1) { input.value = v - 1; }
        updateMinus();
      });

      plus.addEventListener('click', function () {
        var v = parseInt(input.value, 10) || 1;
        if (v < 99) { input.value = v + 1; }
        updateMinus();
      });

      input.addEventListener('change', function () {
        var v = parseInt(input.value, 10);
        if (isNaN(v) || v < 1) v = 1;
        if (v > 99) v = 99;
        input.value = v;
        updateMinus();
      });

      updateMinus();
    }

    function addToCart(card, variantId, btn) {
      if (btn.disabled || btn.dataset.added === 'true') return;
      btn.disabled = true;

      /* Read dynamic quantity from the bottom sheet stepper if it exists */
      var container = btn.closest('.hps-cg-sheet');
      var qtyInput = container ? container.querySelector('.hps-cg__qty-input') : null;
      var qty = parseInt(qtyInput ? qtyInput.value : 1, 10) || 1;

      /* Horizon: request header section re-render for cart count update */
      var sectionId = getHeaderSectionId();

      var body = {
        items: [{ id: parseInt(variantId, 10), quantity: qty, properties: { '_source': 'crosssell-grid' } }]
      };
      if (sectionId) {
        body.sections = sectionId;
        body.sections_url = window.location.pathname;
      }

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(body)
      })
      .then(function (res) {
        if (!res.ok) throw new Error('Cart add failed: ' + res.status);
        return res.json();
      })
      .then(function (data) {
        btn.disabled = false;
        btn.dataset.added = 'true';

        /* Fly-to-Cart: use sheet thumbnail if adding from sheet, else card image */
        var imgToFly = card.querySelector('.hps-cg__card-image');
        if (btn.closest('.hps-cg-sheet') && _sheet) {
          imgToFly = _sheet.querySelector('[data-cg-sheet-thumb]');
        }
        flyToCart(imgToFly);

        /* Horizon: swap cart-notification-bubble from section rendering response */
        if (data.sections && sectionId && data.sections[sectionId]) {
          updateCartBubble(data.sections[sectionId]);
        }

        setTimeout(function () {
          btn.removeAttribute('data-added');
          if (btn.hasAttribute('data-cg-sheet-atc')) closeSheet();
        }, RESET_MS);
      })
      .catch(function (e) {
        console.error('[HPS Grid] Cart add error:', e);
        btn.disabled = false;
      });
    }

    function findSheet() {
      if (!_sheet || !_sheet.isConnected) {
        _sheet = document.querySelector('[data-cg-sheet]');
        if (_sheet) {
          document.body.appendChild(_sheet);
          initQty(_sheet); /* Initialize the stepper inside the bottom sheet */
        }
      }
      if (!_backdrop || !_backdrop.isConnected) {
        _backdrop = document.querySelector('[data-cg-backdrop]');
        if (_backdrop) document.body.appendChild(_backdrop);
      }
      if (_backdrop && !_backdrop._hpsBound) {
        _backdrop.addEventListener('click', closeSheet);
        _backdrop._hpsBound = true;
      }
      if (_sheet && !_sheet._hpsBound) {
        var closeBtn = _sheet.querySelector('[data-cg-sheet-close]');
        if (closeBtn) closeBtn.addEventListener('click', closeSheet);
        
        var sheetAtc = _sheet.querySelector('[data-cg-sheet-atc]');
        if (sheetAtc) {
          sheetAtc.addEventListener('click', function(e) {
            e.preventDefault();
            var vId = sheetAtc.dataset.variantId;
            if (vId && _activeCard) addToCart(_activeCard, vId, sheetAtc);
          });
        }
        _sheet._hpsBound = true;
      }
    }

    function updateSheetState() {
      var matchedVariant = _activeVariants.find(function(v) {
        var match = true;
        if (_activeOptionNames.length > 0 && v.option1 !== _currentSelections[0]) match = false;
        if (_activeOptionNames.length > 1 && v.option2 !== _currentSelections[1]) match = false;
        if (_activeOptionNames.length > 2 && v.option3 !== _currentSelections[2]) match = false;
        return match;
      });

      var sheetThumb = _sheet.querySelector('[data-cg-sheet-thumb]');
      var sheetPrice = _sheet.querySelector('[data-cg-sheet-price]');
      var sheetAtc = _sheet.querySelector('[data-cg-sheet-atc]');
      var sheetSku = _sheet.querySelector('[data-cg-sheet-sku]');
      var sheetAtcIcon = _sheet.querySelector('[data-cg-sheet-atc-icon]');
      var sheetAtcText = _sheet.querySelector('[data-cg-sheet-atc-text]');
      var sheetBadge = _sheet.querySelector('[data-cg-sheet-badge]');
      var sheetQtyWrap = _sheet.querySelector('[data-cg-sheet-qty-wrap]');
      
      var newImgSrc = '';

      if (matchedVariant) {
        /* Assign targeted image URL */
        if (matchedVariant.image) {
          newImgSrc = matchedVariant.image;
        } else if (_activeCard && _activeCard.dataset.cgThumb) {
          newImgSrc = _activeCard.dataset.cgThumb;
        }

        sheetSku.textContent = matchedVariant.sku ? 'Part\u00a0#\u00a0' + matchedVariant.sku : '';
        
        var badgeText = matchedVariant.badge || '';
        var isDiscontinued = badgeText.toLowerCase().trim() === 'discontinued';
        
        /* Dynamic Variant Badge Update */
        if (badgeText && !isDiscontinued) {
          sheetBadge.textContent = badgeText;
          var bClass = badgeText.toLowerCase().replace(/[\s-]/g, '');
          sheetBadge.className = 'badge badge--' + bClass + ' hps-cg-sheet__badge';
          sheetBadge.style.display = '';
        } else {
          sheetBadge.style.display = 'none';
        }

        /* Build Price HTML (handles sale logic) */
        var priceHtml = '';
        if (matchedVariant.compare_at_price > matchedVariant.price) {
          priceHtml = '<span class="hps-cg__price-sale">Sale ' + matchedVariant.price_formatted + '</span> <s class="hps-cg__price-regular">' + matchedVariant.compare_at_price_formatted + '</s>';
        } else {
          priceHtml = matchedVariant.price_formatted;
        }

        if (matchedVariant.available && !isDiscontinued) {
          /* Available State */
          sheetPrice.innerHTML = priceHtml;
          sheetPrice.style.display = '';
          sheetAtc.style.display = '';
          sheetAtc.disabled = false;
          sheetAtc.classList.remove('hps-cg__atc-btn--text');
          sheetAtc.dataset.variantId = matchedVariant.id;
          if(sheetQtyWrap) sheetQtyWrap.style.display = '';
          if(sheetAtcIcon) sheetAtcIcon.style.display = '';
          if(sheetAtcText) sheetAtcText.style.display = 'none';
        } else {
          /* Sold Out or Discontinued State */
          sheetPrice.innerHTML = priceHtml;
          sheetPrice.style.display = isDiscontinued ? 'none' : '';
          
          sheetAtc.style.display = '';
          sheetAtc.disabled = true;
          sheetAtc.classList.add('hps-cg__atc-btn--text');
          if(sheetQtyWrap) sheetQtyWrap.style.display = 'none';
          if(sheetAtcIcon) sheetAtcIcon.style.display = 'none';
          if(sheetAtcText) {
            sheetAtcText.textContent = isDiscontinued ? 'DISCONTINUED' : 'Sold Out';
            sheetAtcText.style.display = '';
          }
        }
      } else {
        /* Unavailable State (No combination exists) */
        if (_activeCard && _activeCard.dataset.cgThumb) {
          newImgSrc = _activeCard.dataset.cgThumb;
        }
        sheetPrice.innerHTML = 'Unavailable';
        sheetPrice.style.display = '';
        sheetSku.textContent = '';
        sheetAtc.style.display = 'none';
        if (sheetQtyWrap) sheetQtyWrap.style.display = 'none';
        if (sheetBadge) sheetBadge.style.display = 'none';
      }

      /* Apply Smooth Fade-in Image Swap */
      var currentRawSrc = sheetThumb.dataset.rawSrc || '';
      if (currentRawSrc !== newImgSrc) {
        sheetThumb.style.opacity = '0';
        sheetThumb.dataset.rawSrc = newImgSrc;

        if (newImgSrc) {
          sheetThumb.src = newImgSrc;
          sheetThumb.style.display = '';
          if (sheetThumb.complete) {
            sheetThumb.style.opacity = '1';
          } else {
            sheetThumb.onload = function() {
              sheetThumb.style.opacity = '1';
            };
          }
        } else {
          sheetThumb.style.display = 'none';
        }
      } else {
        sheetThumb.style.opacity = '1';
      }
    }

    function openSheet(card, variants, optionNames) {
      if (!_sheet || !_backdrop) {
        console.error('[HPS Grid] Sheet or backdrop not found.');
        return;
      }

      /* Mutual exclusivity — close addon-widget sheet if open on same page */
      var addonSheet    = document.querySelector('[data-addon-sheet][data-open]');
      var addonBackdrop = document.querySelector('[data-addon-backdrop]');
      if (addonSheet)    addonSheet.removeAttribute('data-open');
      if (addonBackdrop) addonBackdrop.removeAttribute('data-open');

      _activeCard = card;
      _activeVariants = variants;
      _activeOptionNames = optionNames;
      _currentSelections = [];

      var thumbWrap = _sheet.querySelector('[data-cg-sheet-thumb-wrap]');
      var name = _sheet.querySelector('[data-cg-sheet-name]');
      var container = _sheet.querySelector('[data-cg-sheet-options-container]');
      
      thumbWrap.style.setProperty('--cg-img-ratio', card.dataset.cgRatio || '1');
      name.textContent = card.dataset.cgTitle || '';

      /* Always reset bottom sheet quantity to 1 when opened */
      var sheetQty = _sheet.querySelector('.hps-cg__qty-input');
      if (sheetQty) {
        sheetQty.value = 1;
        sheetQty.dispatchEvent(new Event('change'));
      }

      /* Background Preload Variant Images to prevent flicker */
      var preloadedImages = {};
      variants.forEach(function(v) {
        if (v.image && !preloadedImages[v.image]) {
          var img = new Image();
          img.src = v.image;
          preloadedImages[v.image] = true;
        }
      });

      var initial = variants.find(function(v) { return v.available; }) || variants[0];
      if (initial) {
        if (optionNames.length > 0) _currentSelections[0] = initial.option1;
        if (optionNames.length > 1) _currentSelections[1] = initial.option2;
        if (optionNames.length > 2) _currentSelections[2] = initial.option3;
      }

      container.innerHTML = '';
      optionNames.forEach(function(optName, idx) {
        var optKey = 'option' + (idx + 1);
        var uniqueVals = [];
        variants.forEach(function(v) {
          if (v[optKey] && uniqueVals.indexOf(v[optKey]) === -1) uniqueVals.push(v[optKey]);
        });

        var group = document.createElement('div');
        group.className = 'hps-cg-sheet__option-group';
        var label = document.createElement('p');
        label.className = 'hps-cg-sheet__label';
        label.textContent = optName;
        group.appendChild(label);

        if (uniqueVals.length > 5) {
          var select = document.createElement('select');
          select.className = 'hps-cg-sheet__select';
          uniqueVals.forEach(function(val) {
            var opt = document.createElement('option');
            opt.value = val;
            opt.textContent = val;
            if (val === _currentSelections[idx]) opt.selected = true;
            select.appendChild(opt);
          });
          select.addEventListener('change', function(e) {
            _currentSelections[idx] = e.target.value;
            updateSheetState();
          });
          group.appendChild(select);
        } else {
          var pills = document.createElement('div');
          pills.className = 'hps-cg-sheet__pills';
          uniqueVals.forEach(function(val) {
            var pill = document.createElement('button');
            pill.type = 'button';
            pill.className = 'hps-cg-sheet__pill' + (val === _currentSelections[idx] ? ' is-selected' : '');
            pill.textContent = val;
            pill.addEventListener('click', function() {
              Array.from(pills.children).forEach(function(p) { p.classList.remove('is-selected'); });
              pill.classList.add('is-selected');
              _currentSelections[idx] = val;
              updateSheetState();
            });
            pills.appendChild(pill);
          });
          group.appendChild(pills);
        }
        container.appendChild(group);
      });

      updateSheetState();
      
      var sheetAtc = _sheet.querySelector('[data-cg-sheet-atc]');
      if (sheetAtc) sheetAtc.removeAttribute('data-added');

      _backdrop.setAttribute('data-open', '');
      _sheet.setAttribute('data-open', '');
    }

    function closeSheet() {
      if (!_sheet) return;
      _sheet.removeAttribute('data-open');
      _backdrop.removeAttribute('data-open');
    }

    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-atc-btn]:not([data-cg-sheet-atc])');
      if (!btn) return;
      var card = btn.closest('.hps-cg__card');
      if (!card) return;
      
      e.preventDefault();
      e.stopImmediatePropagation();

      if (btn.disabled || btn.dataset.added === 'true') return;

      var isMulti = card.hasAttribute('data-hps-cg-multi') && card.dataset.hpsCgMulti === 'true';
      if (isMulti) {
        var variantsEl = card.querySelector('[data-cg-variants]');
        var optionsStr = card.dataset.cgOptions;
        if (!variantsEl || !optionsStr) return;

        var variants, optionNames;
        try {
          variants = JSON.parse(variantsEl.textContent || variantsEl.innerHTML);
          optionNames = JSON.parse(optionsStr);
        } catch (err) {
          console.error('[HPS Grid] JSON parse error:', err);
          return;
        }

        findSheet();
        if (_sheet) openSheet(card, variants, optionNames);
        return;
      }

      var variantId = card.dataset.variantId;
      if (!variantId) return;
      addToCart(card, variantId, btn);
    }, true);

    /*
     * shopify:section:load — Horizon fires this when morphSection re-renders.
     * Reset sheet state so findSheet re-discovers from fresh DOM on next click.
     */
    document.addEventListener('shopify:section:load', function () {
      _sheet             = null;
      _backdrop          = null;
      _activeCard        = null;
      _activeVariants    = [];
      _activeOptionNames = [];
      _currentSelections = [];
    });

  }());
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["crosssell-widget"] && !Shopify.designMode) return;
  try {
    (function () {
    'use strict';

    var RESET_MS = 2000;
    var _sheet = null;
    var _backdrop = null;
    var _activeCard = null;
    var _activeVariants = [];
    var _activeOptionNames = [];
    var _currentSelections = [];

    /* ── Horizon cart count — section rendering approach ── */
    function getHeaderSectionId() {
      var h = document.querySelector('.header-section');
      if (h) { var w = h.closest('[id^="shopify-section-"]'); if (w) return w.id.replace('shopify-section-', ''); }
      var c = document.getElementById('header-component');
      if (c) { var w = c.closest('[id^="shopify-section-"]'); if (w) return w.id.replace('shopify-section-', ''); }
      return null;
    }

    function updateCartBubble(sectionHtml) {
      try {
        var doc = new DOMParser().parseFromString(sectionHtml, 'text/html');
        var nb = doc.querySelector('cart-notification-bubble');
        var lb = document.querySelector('cart-notification-bubble');
        if (nb && lb) { lb.outerHTML = nb.outerHTML; return; }
        var ni = doc.querySelector('.header-actions__cart-icon');
        var li = document.querySelector('.header-actions__cart-icon');
        if (ni && li) { li.innerHTML = ni.innerHTML; return; }
        var na = doc.querySelector('header-actions');
        var la = document.querySelector('header-actions');
        if (na && la) la.innerHTML = na.innerHTML;
      } catch (e) { console.warn('[HPS Addon] Cart bubble update failed:', e); }
    }

    function flyToCart(imgEl) {
      if (!imgEl) return;
      var dest = document.querySelector('.header-actions__cart-icon');
      if (!dest) return;
      try {
        var flyEl = document.createElement('fly-to-cart');
        flyEl.style.setProperty('background-image', 'url(' + imgEl.src + ')');
        flyEl.useSourceSize = 'true';
        flyEl.source = imgEl;
        flyEl.destination = dest;
        document.body.appendChild(flyEl);
      } catch (e) {}
    }

    /* Quantity Stepper Initialization */
    function initQty(container) {
      /* Idempotency guard — prevents duplicate listeners from repeated findSheet calls */
      if (container.dataset.qtyInit) return;
      container.dataset.qtyInit = '1';
      var input = container.querySelector('.hps-addon__qty-input');
      var minus = container.querySelector('[data-qty-minus]');
      var plus  = container.querySelector('[data-qty-plus]');
      if (!input || !minus || !plus) return;

      function updateMinus() {
        minus.disabled = parseInt(input.value, 10) <= 1;
      }

      minus.addEventListener('click', function () {
        var v = parseInt(input.value, 10) || 1;
        if (v > 1) { input.value = v - 1; }
        updateMinus();
      });

      plus.addEventListener('click', function () {
        var v = parseInt(input.value, 10) || 1;
        if (v < 99) { input.value = v + 1; }
        updateMinus();
      });

      input.addEventListener('change', function () {
        var v = parseInt(input.value, 10);
        if (isNaN(v) || v < 1) v = 1;
        if (v > 99) v = 99;
        input.value = v;
        updateMinus();
      });

      updateMinus();
    }

    function addToCart(card, variantId, btn) {
      if (btn.disabled || btn.dataset.added === 'true') return;
      btn.disabled = true;

      var container = btn.closest('.hps-addon-sheet') || btn.closest('.hps-addon__card');
      var qtyInput = container ? container.querySelector('.hps-addon__qty-input') : null;
      var qty = parseInt(qtyInput ? qtyInput.value : 1, 10) || 1;

      /* Horizon: request header section re-render for cart count update */
      var sectionId = getHeaderSectionId();

      var body = {
        items: [{ id: parseInt(variantId, 10), quantity: qty, properties: { '_source': 'addon-widget' } }]
      };
      if (sectionId) {
        body.sections = sectionId;
        body.sections_url = window.location.pathname;
      }

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(body)
      })
      .then(function (res) {
        if (!res.ok) throw new Error('Cart add failed: ' + res.status);
        return res.json();
      })
      .then(function (data) {
        btn.disabled = false;
        btn.dataset.added = 'true';

        /* Fly-to-Cart: use sheet thumbnail if adding from sheet, else card image */
        var imgToFly = card.querySelector('.hps-addon__card-image');
        if (btn.closest('.hps-addon-sheet') && _sheet) {
          imgToFly = _sheet.querySelector('[data-addon-sheet-thumb]');
        }
        flyToCart(imgToFly);

        /* Horizon: swap cart-notification-bubble from section rendering response */
        if (data.sections && sectionId && data.sections[sectionId]) {
          updateCartBubble(data.sections[sectionId]);
        }

        setTimeout(function () {
          btn.removeAttribute('data-added');
          if (btn.hasAttribute('data-addon-sheet-atc')) closeSheet();
        }, RESET_MS);
      })
      .catch(function (e) {
        console.error('[HPS Addon] Cart add error:', e);
        btn.disabled = false;
      });
    }

    function findSheet() {
      if (!_sheet || !_sheet.isConnected) {
        _sheet = document.querySelector('[data-addon-sheet]');
        if (_sheet) {
          document.body.appendChild(_sheet);
          initQty(_sheet); 
        }
      }
      if (!_backdrop || !_backdrop.isConnected) {
        _backdrop = document.querySelector('[data-addon-backdrop]');
        if (_backdrop) document.body.appendChild(_backdrop);
      }
      if (_backdrop && !_backdrop._hpsBound) {
        _backdrop.addEventListener('click', closeSheet);
        _backdrop._hpsBound = true;
      }
      if (_sheet && !_sheet._hpsBound) {
        var closeBtn = _sheet.querySelector('[data-addon-sheet-close]');
        if (closeBtn) closeBtn.addEventListener('click', closeSheet);
        
        var sheetAtc = _sheet.querySelector('[data-addon-sheet-atc]');
        if (sheetAtc) {
          sheetAtc.addEventListener('click', function(e) {
            e.preventDefault();
            var vId = sheetAtc.dataset.variantId;
            if (vId && _activeCard) addToCart(_activeCard, vId, sheetAtc);
          });
        }
        _sheet._hpsBound = true;
      }
    }

    function updateSheetState() {
      var matchedVariant = _activeVariants.find(function(v) {
        var match = true;
        if (_activeOptionNames.length > 0 && v.option1 !== _currentSelections[0]) match = false;
        if (_activeOptionNames.length > 1 && v.option2 !== _currentSelections[1]) match = false;
        if (_activeOptionNames.length > 2 && v.option3 !== _currentSelections[2]) match = false;
        return match;
      });

      var sheetThumb = _sheet.querySelector('[data-addon-sheet-thumb]');
      var sheetPrice = _sheet.querySelector('[data-addon-sheet-price]');
      var sheetAtc = _sheet.querySelector('[data-addon-sheet-atc]');
      var sheetSku = _sheet.querySelector('[data-addon-sheet-sku]');
      var sheetAtcIcon = _sheet.querySelector('[data-addon-sheet-atc-icon]');
      var sheetAtcText = _sheet.querySelector('[data-addon-sheet-atc-text]');
      var sheetBadge = _sheet.querySelector('[data-addon-sheet-badge]');
      var sheetQtyWrap = _sheet.querySelector('[data-addon-sheet-qty-wrap]');
      
      var newImgSrc = '';

      if (matchedVariant) {
        /* Assign targeted image URL and update dynamic aspect ratio variable */
        if (matchedVariant.image) {
          newImgSrc = matchedVariant.image;
          if (matchedVariant.image_ratio) {
            sheetThumb.style.setProperty('--addon-img-ratio', matchedVariant.image_ratio);
          }
        } else if (_activeCard && _activeCard.dataset.addonThumb) {
          newImgSrc = _activeCard.dataset.addonThumb;
          sheetThumb.style.setProperty('--addon-img-ratio', _activeCard.dataset.addonRatio || '1');
        }

        sheetSku.textContent = matchedVariant.sku ? 'Part\u00a0#\u00a0' + matchedVariant.sku : '';
        
        var badgeText = matchedVariant.badge || '';
        var isDiscontinued = badgeText.toLowerCase().trim() === 'discontinued';
        
        /* Dynamic Variant Badge Update */
        if (badgeText && !isDiscontinued) {
          sheetBadge.textContent = badgeText;
          var bClass = badgeText.toLowerCase().replace(/[\s-]/g, '');
          sheetBadge.className = 'badge badge--' + bClass + ' hps-addon-sheet__badge';
          sheetBadge.style.display = '';
        } else {
          sheetBadge.style.display = 'none';
        }

        /* Build Price HTML (handles sale logic) */
        var priceHtml = '';
        if (matchedVariant.compare_at_price > matchedVariant.price) {
          priceHtml = '<span class="hps-addon__price-sale">Sale ' + matchedVariant.price_formatted + '</span> <s class="hps-addon__price-regular">' + matchedVariant.compare_at_price_formatted + '</s>';
        } else {
          priceHtml = matchedVariant.price_formatted;
        }

        if (matchedVariant.available && !isDiscontinued) {
          /* Available State */
          sheetPrice.innerHTML = priceHtml;
          sheetPrice.style.display = '';
          sheetAtc.style.display = '';
          sheetAtc.disabled = false;
          sheetAtc.classList.remove('hps-addon-sheet__atc-btn--text');
          sheetAtc.dataset.variantId = matchedVariant.id;
          if(sheetQtyWrap) sheetQtyWrap.style.display = '';
          if(sheetAtcIcon) sheetAtcIcon.style.display = '';
          if(sheetAtcText) sheetAtcText.style.display = 'none';
        } else {
          /* Sold Out or Discontinued State */
          sheetPrice.innerHTML = priceHtml;
          sheetPrice.style.display = '';
          
          sheetAtc.style.display = '';
          sheetAtc.disabled = true;
          sheetAtc.classList.add('hps-addon-sheet__atc-btn--text');
          if(sheetQtyWrap) sheetQtyWrap.style.display = 'none';
          if(sheetAtcIcon) sheetAtcIcon.style.display = 'none';
          if(sheetAtcText) {
            sheetAtcText.textContent = isDiscontinued ? 'DISCONTINUED' : 'SOLD OUT';
            sheetAtcText.style.display = '';
          }
        }
      } else {
        /* Unavailable State (No combination exists) */
        if (_activeCard && _activeCard.dataset.addonThumb) {
          newImgSrc = _activeCard.dataset.addonThumb;
          sheetThumb.style.setProperty('--addon-img-ratio', _activeCard.dataset.addonRatio || '1');
        }
        sheetPrice.innerHTML = '';
        sheetPrice.style.display = 'none';
        sheetSku.textContent = '';
        sheetAtc.style.display = '';
        sheetAtc.disabled = true;
        sheetAtc.classList.add('hps-addon-sheet__atc-btn--text');
        
        if(sheetAtcIcon) sheetAtcIcon.style.display = 'none';
        if(sheetAtcText) {
          sheetAtcText.textContent = 'UNAVAILABLE';
          sheetAtcText.style.display = '';
        }
        if (sheetQtyWrap) sheetQtyWrap.style.display = 'none';
        if (sheetBadge) sheetBadge.style.display = 'none';
      }

      /* Apply Smooth Fade-in Image Swap */
      var currentRawSrc = sheetThumb.dataset.rawSrc || '';
      if (currentRawSrc !== newImgSrc) {
        sheetThumb.style.opacity = '0';
        sheetThumb.dataset.rawSrc = newImgSrc;

        if (newImgSrc) {
          sheetThumb.src = newImgSrc;
          sheetThumb.style.display = '';
          if (sheetThumb.complete) {
            sheetThumb.style.opacity = '1';
          } else {
            sheetThumb.onload = function() {
              sheetThumb.style.opacity = '1';
            };
          }
        } else {
          sheetThumb.style.display = 'none';
        }
      } else {
        sheetThumb.style.opacity = '1';
      }
    }

    function openSheet(card, variants, optionNames) {
      if (!_sheet || !_backdrop) {
        console.error('[HPS Addon] Sheet or backdrop not found.');
        return;
      }

      /* Mutual exclusivity — close crosssell-grid sheet if open on same page */
      var cgSheet    = document.querySelector('[data-cg-sheet][data-open]');
      var cgBackdrop = document.querySelector('[data-cg-backdrop]');
      if (cgSheet)    cgSheet.removeAttribute('data-open');
      if (cgBackdrop) cgBackdrop.removeAttribute('data-open');

      _activeCard = card;
      _activeVariants = variants;
      _activeOptionNames = optionNames;
      _currentSelections = [];

      var thumbWrap = _sheet.querySelector('[data-addon-sheet-thumb-wrap]');
      var name = _sheet.querySelector('[data-addon-sheet-name]');
      var container = _sheet.querySelector('[data-addon-sheet-options-container]');
      
      thumbWrap.style.setProperty('--addon-img-ratio', card.dataset.addonRatio || '1');
      name.textContent = card.dataset.addonTitle || '';

      /* Always reset bottom sheet quantity to 1 when opened */
      var sheetQty = _sheet.querySelector('.hps-addon__qty-input');
      if (sheetQty) {
        sheetQty.value = 1;
        sheetQty.dispatchEvent(new Event('change'));
      }

      /* Background Preload Variant Images to prevent flicker */
      var preloadedImages = {};
      variants.forEach(function(v) {
        if (v.image && !preloadedImages[v.image]) {
          var img = new Image();
          img.src = v.image;
          preloadedImages[v.image] = true;
        }
      });

      var initial = variants.find(function(v) { return v.available; }) || variants[0];
      if (initial) {
        if (optionNames.length > 0) _currentSelections[0] = initial.option1;
        if (optionNames.length > 1) _currentSelections[1] = initial.option2;
        if (optionNames.length > 2) _currentSelections[2] = initial.option3;
      }

      container.innerHTML = '';
      optionNames.forEach(function(optName, idx) {
        var optKey = 'option' + (idx + 1);
        var uniqueVals = [];
        variants.forEach(function(v) {
          if (v[optKey] && uniqueVals.indexOf(v[optKey]) === -1) uniqueVals.push(v[optKey]);
        });

        var group = document.createElement('div');
        group.className = 'hps-addon-sheet__option-group';
        var label = document.createElement('p');
        label.className = 'hps-addon-sheet__label';
        label.textContent = optName;
        group.appendChild(label);

        if (uniqueVals.length > 5) {
          var select = document.createElement('select');
          select.className = 'hps-addon-sheet__select';
          uniqueVals.forEach(function(val) {
            var opt = document.createElement('option');
            opt.value = val;
            opt.textContent = val;
            if (val === _currentSelections[idx]) opt.selected = true;
            select.appendChild(opt);
          });
          select.addEventListener('change', function(e) {
            _currentSelections[idx] = e.target.value;
            updateSheetState();
          });
          group.appendChild(select);
        } else {
          var pills = document.createElement('div');
          pills.className = 'hps-addon-sheet__pills';
          uniqueVals.forEach(function(val) {
            var pill = document.createElement('button');
            pill.type = 'button';
            pill.className = 'hps-addon-sheet__pill' + (val === _currentSelections[idx] ? ' is-selected' : '');
            pill.textContent = val;
            pill.addEventListener('click', function() {
              Array.from(pills.children).forEach(function(p) { p.classList.remove('is-selected'); });
              pill.classList.add('is-selected');
              _currentSelections[idx] = val;
              updateSheetState();
            });
            pills.appendChild(pill);
          });
          group.appendChild(pills);
        }
        container.appendChild(group);
      });

      updateSheetState();
      
      var sheetAtc = _sheet.querySelector('[data-addon-sheet-atc]');
      if (sheetAtc) sheetAtc.removeAttribute('data-added');

      _backdrop.setAttribute('data-open', '');
      _sheet.setAttribute('data-open', '');
    }

    function closeSheet() {
      if (!_sheet) return;
      _sheet.removeAttribute('data-open');
      _backdrop.removeAttribute('data-open');
    }

    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-atc-btn]:not([data-addon-sheet-atc])');
      if (!btn) return;
      var card = btn.closest('.hps-addon__card');
      if (!card) return;
      
      e.preventDefault();
      e.stopImmediatePropagation();

      if (btn.disabled || btn.dataset.added === 'true') return;

      var isMulti = card.hasAttribute('data-hps-addon-multi') && card.dataset.hpsAddonMulti === 'true';
      if (isMulti) {
        var variantsEl = card.querySelector('[data-addon-variants]');
        var optionsStr = card.dataset.addonOptions;
        if (!variantsEl || !optionsStr) return;

        var variants, optionNames;
        try {
          variants = JSON.parse(variantsEl.textContent || variantsEl.innerHTML);
          optionNames = JSON.parse(optionsStr);
        } catch (err) {
          console.error('[HPS Addon] JSON parse error:', err);
          return;
        }

        findSheet();
        if (_sheet) openSheet(card, variants, optionNames);
        return;
      }

      var variantId = card.dataset.variantId;
      if (!variantId) return;
      addToCart(card, variantId, btn);
    }, true);

    /*
     * shopify:section:load — Horizon fires this when morphSection re-renders.
     * Reset sheet state so findSheet re-discovers from fresh DOM on next click.
     */
    document.addEventListener('shopify:section:load', function () {
      _sheet             = null;
      _backdrop          = null;
      _activeCard        = null;
      _activeVariants    = [];
      _activeOptionNames = [];
      _currentSelections = [];
    });

  }());
  } catch(e) { console.error(e); }
})();

})();
